import { extend, configure } from 'vee-validate';
import {
    // eslint-disable-next-line camelcase
    required, email, alpha_num, alpha_spaces, between,
} from 'vee-validate/dist/rules';

// Configure Vee-validate
configure({
    classes: {
        valid: 'is-valid',
        invalid: 'has-error',
    },
});

// Install rules
extend('required', required);
extend('email', email);
extend('alpha_num', alpha_num);
extend('alpha_spaces', alpha_spaces);
extend('between', between);
